import { RequirementsPage } from '@/features/settings/requirements/RequirementsPage'
import { isAdminUser } from '@/lib/role-guards'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/settings/requirements')({
  beforeLoad: ({ context }) => {
    if (context.auth.isLoading) {
      return
    }
    if (!isAdminUser(context.auth.user)) {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: RequirementsPage,
})
